var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function MoneyShieldIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M105.768 2.984H63.876V57.21h43.892V4.984a2 2 0 00-2-2z",
      fill: "#009CEB",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M107.769 57.21v28.13c0 .573-.247 1.119-.676 1.498l-41.892 37.008a2 2 0 01-2.649 0L20.66 86.838a2 2 0 01-.676-1.499V4.984a2 2 0 012-2h41.892V57.21h43.893zM63.875 123.015V55.209M63.876 57.21H19.984",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M85.034 40.282c-4.133-.295-6.101-2.361-6.396-4.822h1.87c.098 1.477 1.377 3.051 4.428 3.248V30.54c-3.05-.59-6.003-1.772-6.003-5.413 0-2.756 2.067-4.822 6.003-5.117v-2.362h1.575v2.361c3.641.296 5.412 2.362 5.708 4.43h-1.87c-.197-1.182-1.28-2.56-3.74-2.855v7.381c3.15.59 6.397 1.575 6.397 5.708 0 3.05-2.263 5.216-6.397 5.511v2.362h-1.575v-2.264zm0-11.612v-6.988c-3.05.296-4.133 1.969-4.133 3.347 0 2.165 1.476 3.05 4.133 3.64zm1.575 2.165v7.774c3.05-.295 4.527-1.968 4.527-3.74 0-2.656-1.771-3.542-4.527-4.034z",
      fill: "#fff"
    })))
  }));
}

export default MoneyShieldIllustration;